import PaymentStatusBadge from "./PaymentStatusBadge";

import {
  formatPaymentAmount,
  formatPaymentDate
} from "../utils/payment.utils";

const PaymentDetails = ({
  payment
}) => {
  if (!payment) {
    return null;
  }

  return (
    <div className="payment-details">
      <div className="payment-details__header">
        <div>
          <span className="payment-details__label">
            Payment
          </span>

          <h1>
            {payment.id}
          </h1>

          <PaymentStatusBadge
            status={
              payment.status
            }
          />
        </div>
      </div>

      <div className="payment-details__grid">
        <section className="payment-details__card">
          <h2>Payment Information</h2>

          <p>
            Amount:{" "}
            <strong>
              {formatPaymentAmount(
                payment.amount,
                payment.currency
              )}
            </strong>
          </p>

          <p>
            Currency:{" "}
            <strong>
              {payment.currency ||
                "—"}
            </strong>
          </p>

          <p>
            Gateway:{" "}
            <strong>
              {payment.gateway ||
                "—"}
            </strong>
          </p>

          <p>
            Status:{" "}
            <PaymentStatusBadge
              status={
                payment.status
              }
            />
          </p>
        </section>

        <section className="payment-details__card">
          <h2>Offer</h2>

          <p>
            Offer Number:{" "}
            <strong>
              {payment.offer_number ||
                "—"}
            </strong>
          </p>

          <p>
            Offer ID:{" "}
            <strong>
              {payment.offer_id ||
                "—"}
            </strong>
          </p>
        </section>

        <section className="payment-details__card">
          <h2>Gateway Information</h2>

          <p>
            Order ID:{" "}
            <strong>
              {payment.gateway_order_id ||
                "—"}
            </strong>
          </p>

          <p>
            Payment ID:{" "}
            <strong>
              {payment.gateway_payment_id ||
                "—"}
            </strong>
          </p>
        </section>

        <section className="payment-details__card">
          <h2>Dates</h2>

          <p>
            Created:{" "}
            <strong>
              {formatPaymentDate(
                payment.created_at
              )}
            </strong>
          </p>

          <p>
            Updated:{" "}
            <strong>
              {formatPaymentDate(
                payment.updated_at
              )}
            </strong>
          </p>

          <p>
            Paid At:{" "}
            <strong>
              {formatPaymentDate(
                payment.paid_at
              )}
            </strong>
          </p>
        </section>
      </div>

      {payment.failure_reason && (
        <section className="payment-details__section">
          <h2>Failure Reason</h2>

          <div className="payment-details__failure">
            {payment.failure_reason}
          </div>
        </section>
      )}
    </div>
  );
};

export default PaymentDetails;
